export const usePersonalDocumentIntro = (goToNextScreen, setIsLoading) => {
  const onSubmit = async e => {
    e.preventDefault()
    setIsLoading(true)
    goToNextScreen()
  }

  return [onSubmit]
}
